/**
 * MerciApp — AI writing assistant
 *
 * A single web-accessible-resource group exposes /static/*, /content.js and
 * /content-chunks/* to every http(s) origin, with no use_dynamic_url. The static tree
 * holds vendor-named icons (merci-icon-*.png) at fixed URLs that load through an <img>
 * with no CORS grant; content-chunks are build-hashed, so the stable merci icons and
 * content.js are the paths to probe.
 *
 * Manifest verified against version 3.104.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gccahjgcckaemgpliioopngfgdaceffo';

export const merciApp: ExtensionDefinition = {
  id: ID,
  name: 'MerciApp - AI Writing Assistant',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'static/* and content.js exposed to every http(s) origin with no dynamic URL. The ' +
    'vendor-named merci icons load without a CORS grant; a content.js fetch corroborates.',
  signals: [
    {
      id: 'war-merci-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load static/metadata/merci-icon-128-production.png via <img> — a vendor-named ' +
        'icon exposed to every http(s) origin, reachable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'static/metadata/merci-icon-128-production.png'),
    },
    {
      id: 'war-merci-icon-64',
      kind: 'web-accessible-resource',
      description:
        'Load static/metadata/merci-icon-64-production.png via <img> — a second vendor ' +
        'icon, corroborating without CORS.',
      weight: 0.5,
      run: () => probeImage(ID, 'static/metadata/merci-icon-64-production.png'),
    },
    {
      id: 'war-content-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content.js — the injected entry point, a path independent of the icons.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content.js'),
    },
  ],
};
